import React from "react";

const MentorAbout = ({ mentor }) => {
  return (
    <div className="p-[20px]">
      <div>
        <h4 className="text-lg font-semibold mb-2">About</h4>
        <div className="flex flex-wrap gap-2">
          {mentor?.about}
        </div>
      </div>
    </div>
  );
};

export default MentorAbout;
